import React, { forwardRef } from 'react';
import { buildClassName } from '../../../utils';
import styles from '../DesktopNavigation.module.scss';

/**
 * @internal
 * Base navigation button component that provides consistent styling and behavior
 * for all navigation item types (link, dropdown, custom).
 */

interface NavigationButtonBaseProps {
  children: React.ReactNode;
  className?: string;
  isExpanded?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: () => void;
  'aria-expanded'?: boolean;
  'aria-label'?: string;
  'data-testid'?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const NavigationButtonBase = forwardRef<HTMLButtonElement, NavigationButtonBaseProps>(
  ({ 
    children, 
    className, 
    isExpanded = false,
    onClick,
    onMouseEnter,
    'aria-expanded': ariaExpanded,
    'aria-label': ariaLabel,
    'data-testid': testId,
    disabled = false,
    type = 'button',
    ...rest 
  }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={buildClassName(styles.navButton, className)}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        aria-expanded={ariaExpanded ?? isExpanded}
        aria-label={ariaLabel}
        data-testid={testId}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

NavigationButtonBase.displayName = 'NavigationButtonBase'; 